import { EClassNamesCellBorder as ECB } from '@/pages/_base/grid2d_cell/EClassNamesCellBorder';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD_GRID2D_MODE__all_loras_except_one } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__all_loras_except_one';
import { FIELD_GRID2D_MODE__lora_after_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_after_lora';
import { FIELD_GRID2D_MODE__single_lora_generation } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__single_lora_generation';
import { FIELD_GRID2D_MODE__all_tokens_except_one } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__all_tokens_except_one';
import { FIELD_GRID2D_MODE__single_token_generation } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__single_token_generation';
import { FIELD_GRID2D_MODE__token_after_token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__token_after_token';
import { DTO__grid2d_cell_generation } from '@shared/dto/grid2d_cell/DTO__grid2d_cell_generation';
import { useMemo } from 'react';
import { use_slice_ui } from '../../../../hooks/store/use_slices';

export function HOOK_GRID2D_CELL_GENERATION__class_name_hover(cell: DTO__grid2d_cell_generation) {
  const { g_hovered_grid2d_column, g_hovered_grid2d_row, g_hovered_grid2d_dimension_from_grid } = use_slice_ui([
    'g_hovered_grid2d_column',
    'g_hovered_grid2d_row',
    'g_hovered_grid2d_dimension_from_grid',
  ]);

  const field_row = useMemo(() => get_field(cell.field_row), [cell]);
  const field_column = useMemo(() => get_field(cell.field_column), [cell]);

  /*
   *
   */

  function get_field(field: FIELD__base) {
    if (field instanceof FIELD_GRID2D_MODE__token_after_token) return FIELD_GRID2D_MODE__token_after_token.CREATE_STUB();
    if (field instanceof FIELD_GRID2D_MODE__lora_after_lora) return FIELD_GRID2D_MODE__lora_after_lora.CREATE_STUB();
    if (field instanceof FIELD_GRID2D_MODE__single_lora_generation) return FIELD_GRID2D_MODE__single_lora_generation.CREATE_STUB();
    if (field instanceof FIELD_GRID2D_MODE__single_token_generation) return FIELD_GRID2D_MODE__single_token_generation.CREATE_STUB();
    if (field instanceof FIELD_GRID2D_MODE__all_loras_except_one) return FIELD_GRID2D_MODE__all_loras_except_one.CREATE_STUB();
    if (field instanceof FIELD_GRID2D_MODE__all_tokens_except_one) return FIELD_GRID2D_MODE__all_tokens_except_one.CREATE_STUB();

    return field;
  }
  /*
   * ROW
   */

  const class_name_hovered_from_settngs_row = useMemo(() => {
    if (g_hovered_grid2d_row.is_stub()) return '';
    if (g_hovered_grid2d_dimension_from_grid) return '';

    const is_edge_l = cell.x === 0;
    const is_edge_r = field_column.is_stub() ? false : cell.x === field_column.grid2d_dimension_values.length - 1;

    const is_hovered_button_used_grid2d_dimension = field_row.is_equal(g_hovered_grid2d_row);

    let out = [ECB.TRANSITION_DURATION];
    out.push(is_hovered_button_used_grid2d_dimension ? ECB.BORDER_T : ECB.BORDER_T_OPACITY);
    out.push(is_hovered_button_used_grid2d_dimension ? ECB.BORDER_B : ECB.BORDER_B_OPACITY);

    if (is_edge_l) out.push(`${is_hovered_button_used_grid2d_dimension ? ECB.BORDER_L : ECB.BORDER_L_OPACITY} ${ECB.ROUNDED_L}`);
    if (is_edge_r) out.push(`${is_hovered_button_used_grid2d_dimension ? ECB.BORDER_R : ECB.BORDER_R_OPACITY} ${ECB.ROUNDED_R}`);

    return out.join(' ');
  }, [cell.x, g_hovered_grid2d_row, g_hovered_grid2d_dimension_from_grid]);

  /*
   * COLUMN
   */

  const class_name_hovered_from_settngs_column = useMemo(() => {
    if (g_hovered_grid2d_column.is_stub()) return '';
    if (g_hovered_grid2d_dimension_from_grid) return '';

    const is_edge_t = cell.y === 0;
    const is_edge_b = field_row.is_stub() ? false : cell.y === field_row.grid2d_dimension_values.length - 1;
    const is_hovered_button_used_grid2d_dimension = field_column.is_equal(g_hovered_grid2d_column);

    let out = [ECB.TRANSITION_DURATION];
    out.push(is_hovered_button_used_grid2d_dimension ? ECB.BORDER_R : ECB.BORDER_R_OPACITY);
    out.push(is_hovered_button_used_grid2d_dimension ? ECB.BORDER_L : ECB.BORDER_L_OPACITY);

    if (is_edge_t) out.push(`${is_hovered_button_used_grid2d_dimension ? ECB.BORDER_T : ECB.BORDER_T_OPACITY} ${ECB.ROUNDED_T}`);
    if (is_edge_b) out.push(`${is_hovered_button_used_grid2d_dimension ? ECB.BORDER_B : ECB.BORDER_B_OPACITY} ${ECB.ROUNDED_B}`);

    return out.join(' ');
  }, [cell.y, g_hovered_grid2d_column, g_hovered_grid2d_dimension_from_grid]);

  /*
   *
   */

  const class_name_hovered_cell = useMemo(() => {
    let out: string[] = [ECB.DEFAULT_BORDER, ECB.TRANSITION_DURATION];

    if (g_hovered_grid2d_row.is_stub() && g_hovered_grid2d_column.is_stub()) return out.join(' ');

    const is_is_hovered__x = g_hovered_grid2d_column.is_equal(field_column);
    const is_is_hovered__y = g_hovered_grid2d_row.is_equal(field_row);

    if (!is_is_hovered__x && !is_is_hovered__y) return out.join(' ');

    const is_edge_t = cell.y === 0;
    const is_edge_b = field_row.is_stub() ? false : cell.y === field_row.grid2d_dimension_values.length - 1;
    const is_edge_l = cell.x === 0;
    const is_edge_r = field_column.is_stub() ? false : cell.x === field_column.grid2d_dimension_values.length - 1;

    out.push(is_is_hovered__y || is_is_hovered__x ? ' opacity-100' : ' opacity-80');

    if (is_edge_b && is_edge_r) out.push(ECB.ROUNDED_BR);
    if (is_edge_t && is_edge_r) out.push(ECB.ROUNDED_TR);
    if (is_edge_b && is_edge_l) out.push(ECB.ROUNDED_BL);
    if (is_edge_t && is_edge_l) out.push(ECB.ROUNDED_TL);

    if (is_is_hovered__y && is_is_hovered__x) {
      if (is_edge_t) out.push(ECB.BORDER_T);
      if (is_edge_b) out.push(ECB.BORDER_B);
      if (is_edge_l) out.push(ECB.BORDER_L);
      if (is_edge_r) out.push(ECB.BORDER_R);

      return out.join(' ');
    }

    if (is_is_hovered__y) {
      out.push(`${ECB.BORDER_Y}`);

      if (is_edge_l && !is_is_hovered__x) out.push(`${ECB.BORDER_L} ${ECB.ROUNDED_L}`);
      if (is_edge_r && !is_is_hovered__x) out.push(`${ECB.BORDER_R} ${ECB.ROUNDED_R}`);
    }

    if (is_is_hovered__x) {
      out.push(`${ECB.BORDER_X}`);

      if (is_edge_t && !is_is_hovered__y) out.push(`${ECB.BORDER_T} ${ECB.ROUNDED_T}`);
      if (is_edge_b && !is_is_hovered__y) out.push(`${ECB.BORDER_B} ${ECB.ROUNDED_B}`);
    }

    return out.join(' ');
  }, [cell.x, cell.y, g_hovered_grid2d_row, g_hovered_grid2d_column, g_hovered_grid2d_dimension_from_grid]);

  return `${class_name_hovered_from_settngs_row} ${class_name_hovered_from_settngs_column} ${class_name_hovered_cell}`.trim();
}
